import useGetQuery from '_api/queries/useGetQuery';
import { ConstantsNameDescriptions } from '_api/types';

export const GET_PATIENT_ETHNICITY = 'get-patient-ethnicity';

export const useGetPatientEthnicity = () =>
  useGetQuery<ConstantsNameDescriptions<string>[]>(
    () => `/constant/ethnicity`,
    {},
    [GET_PATIENT_ETHNICITY],
    {
      refetchOnWindowFocus: false,
    },
  );
